




















































import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import Vue from "vue";
import { onBeforeUnmount, onMounted, Ref, ref } from "@vue/composition-api";
import * as api from "./api";
import { TypeSeveritiesItem } from "./api";
import { UseLoading } from "@/common/composition/loading";
import VirtualTable from "@/components/table/VirtualTable.vue";
import LevelLabel from "@/components/LevelLabel.vue";
import TableRow from "./TableRow.vue";
import { table_config } from "./table.config";
import { SharedState } from "@/common/state";
import { EventsModalProps } from "@/components/modals/events-modal/model";
import { AxisType, CoordinateInputTier3 } from "@/gql/types";
import EventsModal from "@/components/modals/events-modal/EventsModal.vue";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import { InvestigateSingleEntity } from "@/common/menu-items";
import { POPULATION_TYPE } from "@/common/models";
export default Vue.extend({
  props: ["modalData"],
  components: { Modal, VirtualTable, LevelLabel },
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "100rem",
      height: "60rem",
      withTopRightCloseBtn: true,
    };
    const [is_loading, set_is_loading] = UseLoading(false).as_arr();
    const items: Ref<TypeSeveritiesItem[]> = ref([]);

    const show_events_modal = async (item: {
      severity: number;
      id: string;
    }) => {
      SharedState.ifIsPayingUser(
        async () => {
          const { type, from } = SharedState.selectedTimeFrameOption.value;
          const label = SharedState.allInfoTypes.value[item.id];
          const level = ["None", "Low", "Medium", "High"][item.severity];
          await UseModal().show(EventsModal, {
            // @ts-ignore
            source: props.modalData.source || "",
            title: `<b>${level} severity</b> Events including <b>${label.labelName}</b> information`,
            files_title: `<b>${label.labelName}</b> files included in <b>${level} severity</b> Events`,
            hide_filters: ["severities"],
            coordinates: [
              {
                x: {
                  type: AxisType.ContentLabel,
                  values: [item.id],
                },
                y: {
                  type: AxisType.Severity,
                  values: [item.severity.toString()],
                },
                z: {
                  type,
                  values: [from],
                },
              },
            ] as CoordinateInputTier3[],
          } as EventsModalProps);
        },
        { premium_modal_key: "risks-popup-2024" }
      );
    };

    const subs = {
      events: emptyFn(),
      menu: emptyFn(),
    };
    onMounted(async () => {
      subs.events = EventBus.listen("show-events", show_events_modal);
      subs.menu = EventBus.listen(
        "show-menu",
        async (p: { item: any; event: MouseEvent }) => {
          const res = await UseDrillDownMenu().show({
            menu: [InvestigateSingleEntity("Label")(p.item.name)],
            event: p.event,
          });
          if (res.didUserSelectedAnAction) {
            if (res.actionSelected === "investigate_entity") {
              if (
                SharedState.restrictions.is_restricted_app(
                  "entity_investigation"
                )
              ) {
                SharedState.restrictions.show_restrictions_modal(
                  "app",
                  "Entity Investigation"
                );
              } else {
                SharedState.investigation.investigate({
                  id: p.item.id,
                  type: POPULATION_TYPE.LABEL,
                  name: p.item.name,
                  ...p.item,
                });
              }
            }
          }
        }
      );
      set_is_loading(true);
      // @ts-ignore
      const labels_ids: string[] = props.modalData.label_ids as string[];
      const res = await api.get_severities_for_info_type_children(labels_ids);
      if (res.success) {
        // @ts-ignore
        items.value = SharedState.filter_out_deleted_labels(res.value);
      }
      set_is_loading(false);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((ubsub) => ubsub()));

    return {
      config,
      table_config,
      is_loading,
      items,
      TableRow,
    };
  },
});
